import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import Classes from './views/Classes.vue'
import Bookings from './views/Bookings.vue'
import Members from './views/Members.vue'
import Ledger from './views/Ledger.vue'

Vue.use(Router)
const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/login', component: Login, meta: { public: true } },
    { path: '/dashboard', component: Dashboard },
    { path: '/classes', component: Classes },
    { path: '/bookings', component: Bookings },
    { path: '/members', component: Members },
    { path: '/ledger', component: Ledger },
    { path: '*', redirect: '/dashboard' }
  ]
})
router.beforeEach((to, from, next) => {
  if (!to.meta.public && !localStorage.getItem('admin_token')) next('/login')
  else if (to.path === '/login' && localStorage.getItem('admin_token')) next('/dashboard')
  else next()
})
export default router
